/** 业务场景，可扩展 */
export enum TCaptchaScene {
  /** 运营活动 */
  prom = 'prom',
}

export type TCaptchaResult = {
  ret: number,
  ticket: string,
  appid: string,
  randstr: string,
  errorCode: number
  errorMessage: string
};

export enum TCaptchaResultRet {
  normal = 0, // 正常
  cancel = 2 // 用户关闭
}
